import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=3b58cacf&scoped=true&"
import script from "./ToggleButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=3b58cacf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58cacf",
  null
  
)

export default component.exports